import { render, staticRenderFns } from "./divideModal.vue?vue&type=template&id=6572a0ef&scoped=true&"
import script from "./divideModal.vue?vue&type=script&lang=js&"
export * from "./divideModal.vue?vue&type=script&lang=js&"
import style0 from "./divideModal.vue?vue&type=style&index=0&id=6572a0ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572a0ef",
  null
  
)

export default component.exports